import {
	ADMINGETFEEDEFAULTVALUES_SUCCESS,
	ADMINGETFEEDEFAULTVALUES_FAILED,
	RESET_ADMINGETFEEDEFAULTVALUES,
	LOADING_ADMINGETFEEDEFAULTVALUES,
	NETWORK_ERROR_ADMINGETFEEDEFAULTVALUES
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetFeeDefaultValues = () => {
	return { type: RESET_ADMINGETFEEDEFAULTVALUES };
};

const adminGetFeeDefaultValues =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINGETFEEDEFAULTVALUES });
		await adminServices
			.post("getFeeDefaultValues", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminGetFeeDefaultValuessuccess(res.data));
						break;
					default:
						dispatch(adminGetFeeDefaultValuesFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINGETFEEDEFAULTVALUES,
					payload: err
				});
			});
	};
function adminGetFeeDefaultValuessuccess(data) {
	return {
		type: ADMINGETFEEDEFAULTVALUES_SUCCESS,
		payload: data
	};
}
function adminGetFeeDefaultValuesFailed(data) {
	return {
		type: ADMINGETFEEDEFAULTVALUES_FAILED,
		payload: data
	};
}

export { resetAdminGetFeeDefaultValues, adminGetFeeDefaultValues };
